import React, {useEffect, useState} from "react";
import {ElementsConsumer, PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";

const CheckoutForm = (props) => {

    const {saved, setSuccess} = props;
    const [errorMessage, setErrorMessage] = useState('');

    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async () => {

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            return;
        }

        const result = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: "https://scored.co/",
            },
            redirect: 'if_required',
        });


        if (result.error) {
            // Show error to your customer (for example, payment details incomplete)
            console.log(result.error.message);
            setErrorMessage(result.error.message);
        } else {
            setSuccess(true);
        }
    };

    useEffect(() => {
        if (saved > 0) {
            handleSubmit().then();
        }
    }, [saved]);

        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <PaymentElement />
                    {errorMessage &&
                        <p style={{color: 'red', marginTop: 12, fontSize: '14px'}}>{errorMessage}</p>
                    }
                </form>
            </div>
        );

};

export default function InjectedCheckoutForm(props) {
    return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <CheckoutForm stripe={stripe} elements={elements} saved={props.saved} setSuccess={props.setSuccess}/>
            )}
        </ElementsConsumer>
    );
}